// A simple service to expose the notistack enqueueSnackbar function to be used outside of components.
class SnackbarService {
  snackbar = null;

  setSnackbar(snackbar) {
    this.snackbar = snackbar;
    console.log('SnackbarService: Snackbar instance set', this.snackbar);
  }

  enqueueSnackbar(message, options) {
    console.log('SnackbarService: Attempting to enqueueSnackbar', { message, options, snackbarInstance: this.snackbar });
    if (this.snackbar) {
      this.snackbar(message, options);
    } else {
      console.error('SnackbarService: enqueueSnackbar called but snackbar instance is null.');
    }
  }
}

export const snackbarService = new SnackbarService();
